import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTabletCheck = () => {
  return (
    <g>
      <path d="M15 14.95c0 .541-.41.987-.936 1.044L13.95 16H2.05a1.05 1.05 0 0 1-1.044-.936L1 14.95V1.05c0-.54.41-.986.936-1.043L2.05 0l11.901.017c.541 0 .986.41 1.043.936l.006.114V14.95zm-1.5-1.45h-11v1h11v-1zm0-9.5h-11v8h11V4zm-2.424 1.672a.75.75 0 0 1 .072.977l-.072.084-3.486 3.486a.75.75 0 0 1-.977.072l-.084-.072-1.634-1.634A.75.75 0 0 1 5.87 7.45l.084.073L7.06 8.627l2.956-2.955a.75.75 0 0 1 1.06 0zM2.5 1.501v.998h11v-.983l-11-.015z" />
    </g>
  );
};

export default withIcon(IconTabletCheck);
